
import Authenticator from '../../components/Authenticator/Authenticator';
import { Pages } from '../../components/Pages/Pages';
import DraftCompletePage from '../../pages/DraftCompletePage/DraftCompletePage';
import HowToGetOfferPage from '../../pages/HowToApplyPage/HowToGetOfferPage';
import RequestNorskGjeldConsentPage from '../../pages/RequestNorskGjeldConsentPage/RequestNorskGjeldConsentPageNO';
import DraftRequestSBLConsentPage from '../../pages/RequestSBLConsentPage/DraftRequestSBLConsentPage';

const DraftWizard = () => {
    return (
        <Pages>
            <HowToGetOfferPage />
            <DraftRequestSBLConsentPage />
            <Authenticator autoLogin={true}>
                <RequestNorskGjeldConsentPage />
            </Authenticator>
            <DraftCompletePage />
        </Pages>
    );
};

export default DraftWizard;
